import React, { useState } from "react";
import "./sideBar.scss";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.svg";
import Logout from "../../assets/images/logout.svg";
import Notes from "../../assets/images/notes.svg";
import ActiveNotes from "../../assets/images/activeNotes.svg";
import Profile from "../../assets/images/profile.svg";

function SideBar({showSideBar}) {
  let navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("dashboard");

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className={`sideBar ${showSideBar ? "" : "hidden"}`}>
      <div className="logoWrapper">
        <img className="logo" src={Logo} alt="logo" />
        <span className="title">کارماراتو مدیریت کن</span>
      </div>
      <div
        className={activeMenu === "dashboard" ? "activeMenuBtn" : "menuBtn"}
        onClick={() => {
          setActiveMenu("dashboard");
          navigate("/dashboard");
        }}
      >
        <img
          src={activeMenu === "dashboard" ? ActiveNotes : Notes}
          alt="icon"
        />
        داشبورد
      </div>
      <div
        className={activeMenu === "test" ? "activeMenuBtn" : "menuBtn"}
        onClick={() => {
          setActiveMenu("notes");
          navigate("/example");
        }}
      >
        <img
          src={activeMenu === "test" ? ActiveNotes : Notes}
          alt="icon"
        />
        یادداشت ها
      </div>
      <div className="profileWrapper">
        <div className="profile">
          <img src={Profile} alt="avatar" />
          <p>{localStorage.getItem("fullname")}</p>
        </div>
        <div className="exit" onClick={logout}>
          <img
            src={Logout}
            alt="logout"
          />
          <p>خروج</p>
        </div>
      </div>
      {/* <div className="softwareData">
       <span className="bold">نسخه: 1.0</span>
       <br />
        UX و برنامه نویس:
        سامان میرعلی یاری
        <br />
        UI:
         فرهاد گودرزی
      </div> */}
    </div>
  );
}
export default SideBar;
